var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 34,
    viewBox: "0 0 59 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_4243)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 34,
    rx: 8,
    fill: "#D7E2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0262 22V12.2H23.4242V13.642H18.8182V16.33H23.0042V17.73H18.8182V20.558H23.4242V22H17.0262ZM28.27 22.168C27.6166 22.168 27.0333 22.0093 26.52 21.692C26.0066 21.3747 25.6006 20.9407 25.302 20.39C25.0033 19.8393 24.854 19.214 24.854 18.514C24.854 17.814 25.0033 17.1933 25.302 16.652C25.6006 16.1013 26.0066 15.672 26.52 15.364C27.0333 15.0467 27.6166 14.888 28.27 14.888C28.7926 14.888 29.25 14.986 29.642 15.182C30.034 15.378 30.3513 15.6533 30.594 16.008V11.92H32.386V22H30.79L30.594 21.006C30.37 21.314 30.0713 21.5847 29.698 21.818C29.334 22.0513 28.858 22.168 28.27 22.168ZM28.648 20.6C29.2266 20.6 29.698 20.4087 30.062 20.026C30.4353 19.634 30.622 19.1347 30.622 18.528C30.622 17.9213 30.4353 17.4267 30.062 17.044C29.698 16.652 29.2266 16.456 28.648 16.456C28.0786 16.456 27.6073 16.6473 27.234 17.03C26.8606 17.4127 26.674 17.9073 26.674 18.514C26.674 19.1207 26.8606 19.62 27.234 20.012C27.6073 20.404 28.0786 20.6 28.648 20.6ZM35.1768 13.978C34.8501 13.978 34.5794 13.88 34.3648 13.684C34.1594 13.488 34.0568 13.2407 34.0568 12.942C34.0568 12.6433 34.1594 12.4007 34.3648 12.214C34.5794 12.018 34.8501 11.92 35.1768 11.92C35.5034 11.92 35.7694 12.018 35.9748 12.214C36.1894 12.4007 36.2968 12.6433 36.2968 12.942C36.2968 13.2407 36.1894 13.488 35.9748 13.684C35.7694 13.88 35.5034 13.978 35.1768 13.978ZM34.2808 22V15.056H36.0728V22H34.2808ZM41.0372 22C40.3092 22 39.7259 21.8227 39.2872 21.468C38.8485 21.1133 38.6292 20.4833 38.6292 19.578V16.554H37.4392V15.056H38.6292L38.8392 13.194H40.4212V15.056H42.2972V16.554H40.4212V19.592C40.4212 19.928 40.4912 20.1613 40.6312 20.292C40.7805 20.4133 41.0325 20.474 41.3872 20.474H42.2552V22H41.0372Z",
    fill: "#246BFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_4243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 34,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/edit-button.d2cbbcc0b3f88962819d44db053b5020.svg";
export { ForwardRef as ReactComponent };